import { Schedule, ScheduleDetail, ScheduleSendable } from '@/entities/schedule';
import { intoSendableRule } from '@/services/api/resources/rrule';
import { filterListToEditableGroups, filterListToEditableUsers } from '@/ui/helpers';

export function intoEditable(data: ScheduleDetail): Schedule {
  return {
    ...data.data,
    title: data.data.title || '',
    checklists: data.data.checklists.map(checklist => checklist.id),
    assignees: data.data.assignees.map(user => `user_${user.id}`),
    assignedGroups: data.data.assignedGroups.map(group => `group_${group.id}`),
    supervisors: data.data.supervisors.map(user => `user_${user.id}`),
    supervisorGroups: data.data.supervisorGroups.map(group => `group_${group.id}`),
    entities: data.data.entities.map(entity => entity.id),
  };
}

export function intoSendable(data: Schedule): ScheduleSendable {
  const {
    assignees,
    assignedGroups,
    supervisors,
    supervisorGroups,
    entities,
    allEntityItems,
    rule,
    ...rest
  } = data;

  return {
    ...rest,
    rule: intoSendableRule(rule),
    assignees: {
      users: filterListToEditableUsers(assignees),
      groups: filterListToEditableGroups(assignedGroups),
      entityItems: entities,
      allEntityItems,
    },
    supervisors: {
      users: filterListToEditableUsers(supervisors),
      groups: filterListToEditableGroups(supervisorGroups),
    },
  };
}
